import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=

*/
async function handlePostBudget(fetch, operations, research, materials, billingCode) {
    console.log('operations, research,', operations, research, materials)
    const body = {
        operationsBudget: operations.map((hour) => ({
            task: { id: hour.id },
            projectedHours: hour.projectedHours,
        })),
        researchBudget: research.map((hour) => ({
            task: { id: hour.id },
            projectedHours: hour.projectedHours,
        })),
        materialsBudget: materials.map(material => ({
            materialName: material.name,
            cost: material.cost,
        })),
        billingCode: billingCode,
    };
    
    const response = await fetch.post(`${apiBaseURL}/api/budget`, body);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    console.log('handlePostBudget body', body);
    console.log('handlePutBudget response', response); 

    return {
        response,
        isDataGood
    };
}
export default handlePostBudget;